import React from "react";
import { isEmpty } from "shared/utils";
import { EnabledFeatureContextType } from "./type";
import useEnabledFeatureContextProviderService from "./service";

const EnabledFeatureContext = React.createContext<EnabledFeatureContextType>({
  isAddOnInventoryEnabled: eventId => false,
  isMyPrivilegesEnabled: false,
  isPDFTemplateEnabled: templateName => false,
  isPostEventSummaryEnabled: eventId => false,
  isAITextEnhancementEnabled: false
});

export function EnabledFeatureContextProvider(props: React.PropsWithChildren<{}>) {
  const service = useEnabledFeatureContextProviderService();

  const providerData: EnabledFeatureContextType = React.useMemo(() => {
    return {
      isPDFTemplateEnabled: service.isPDFTemplateEnabled,
      isMyPrivilegesEnabled: service.isMyPrivilegesEnabled,
      isAddOnInventoryEnabled: service.isAddOnInventoryEnabled,
      isPostEventSummaryEnabled: service.isPostEventSummaryEnabled,
      isAITextEnhancementEnabled: service.isAITextEnhancementEnabled
    };
  }, [
    service.isPDFTemplateEnabled,
    service.isMyPrivilegesEnabled,
    service.isAddOnInventoryEnabled,
    service.isPostEventSummaryEnabled,
    service.isAITextEnhancementEnabled
  ]);

  if (!service.enabledFeatureList && service.isLoggedIn()) {
    return null;
  }

  return <EnabledFeatureContext.Provider value={providerData}>{props.children}</EnabledFeatureContext.Provider>;
}

export function useEnabledFeatures() {
  const context = React.useContext(EnabledFeatureContext);
  if (isEmpty(context)) {
    throw new Error(`useEnabledFeatures must be used within a EnabledFeatureContextProvider`);
  }
  return context;
}
